import React from 'react';
import { classnames } from 'helpers/utils';
import styles from './counter-badge.module.scss';

type CounterBadgeProps = {
  amount: number;
  className?: string;
};

const CounterBadge: React.FC<CounterBadgeProps> = ({
  amount,
  className = '',
}) => {
  const classes = classnames(...[className, styles.badge]);
  return (
    <div
      className={classnames(classes, 'text__body__semi__bold__overline__white')}
    >
      {amount}
    </div>
  );
};

export { CounterBadge };
